module.exports = __webpack_public_path__ + "img/empty.794e3a03.png";